import {createWebHistory, createRouter} from "vue-router";
import App from "../App.vue";

export const routes = [

    {
        name: 'App',
        path: '/',
        component: App,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes: routes,
});

export default router;
